import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'patient-portal-health-record',
  ['LOAD_MORE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'ccda',
    'user_documents',
    {
      type: 'payload.query',
      queryParameter: 'start_date',
      selector: 'startDate',
    },
    {
      type: 'payload.query',
      queryParameter: 'end_date',
      selector: 'endDate',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

const initialState = {
  ...requestInitialState,
  list: [],
  total: 0,
  isPagination: false,
};

const requestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SEND:
      return {
        ...state,
        succeed: false,
        sending: true,
        isPagination: payload.withPagination,
      };
    case consts.SUCCEED:
      return {
        ...state,
        succeed: true,
        sending: false,
        isLastPage: true,
        list: state.isPagination ? state.list.concat(payload) : payload,
      };
    case consts.ADD_META:
      return { ...state, total: payload.total };
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/health-record-req.js